import { createSelector } from "reselect"
import { get } from "lodash"

const getFeatures = state => get(state, "global.data.enabledFeatures.data", false)
const getAiTermsAndConditions = state => get(state, "global.data.aiTermsAndConditions.data", false)

export const getIsAiQuickAnswersEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "ai_quick_answers", false),
)

export const getIsDashboardEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "dashboard", false),
)

export const getIsDashboardIntradayFeatureEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "dashboard_intraday", false),
)

export const getAiQuickAnswersEnabledAndTermsAccepted = createSelector(
  [getIsAiQuickAnswersEnabled, getAiTermsAndConditions],
  (isAiQuickAnswersEnabled, aiTerms) => isAiQuickAnswersEnabled && get(aiTerms, "enabled"),
)

export const getIsRfrAttributionEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "rfr_attribution", false),
)

export const getIsBenchmarkEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "benchmark_data_type", false),
)
